import { render } from "./event-type.vue?vue&type=template&id=6e9414f2&ts=true"
import script from "./event-type.vue?vue&type=script&lang=ts"
export * from "./event-type.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__